import React from "react";
import Crosole from "../../Crosole/Crosole";

const Home = () => {
  return (
    <div>
      <Crosole />
      <div>
        A paragraph is defined as “a group of sentences or a single sentence
        that forms a unit” (Lunsford and Connors 116). Length and appearance do
        not determine whether a section in a paper is a paragraph. For instance,
        in some styles of writing, particularly journalistic styles, a paragraph
        can be just one sentence long.A paragraph is defined as “a group of
        sentences or a single sentence that forms a unit” (Lunsford and Connors
        116). Length and appearance do not determine whether a section in a
        paper is a paragraph. For instance, in some styles of writing,
        particularly journalistic styles, a paragraph can be just one sentence
        long.A paragraph is defined as “a group of sentences or a single
        sentence that forms a unit” (Lunsford and Connors 116). Length and
        appearance do not determine whether a section in a paper is a paragraph.
        For instance, in some styles of writing, particularly journalistic
        styles, a paragraph can be just one sentence long.A paragraph is defined
        as “a group of sentences or a single sentence that forms a unit”
        (Lunsford and Connors 116). Length and appearance do not determine
        whether a section in a paper is a paragraph. For instance, in some
        styles of writing, particularly journalistic styles, a paragraph can be
        just one sentence long.A paragraph is defined as “a group of sentences
        or a single sentence that forms a unit” (Lunsford and Connors 116).
        Length and appearance do not determine whether a section in a paper is a
        paragraph. For instance, in some styles of writing, particularly
        journalistic styles, a paragraph can be just one sentence long.A
        paragraph is defined as “a group of sentences or a single sentence that
        forms a unit” (Lunsford and Connors 116). Length and appearance do not
        determine whether a section in a paper is a paragraph. For instance, in
        some styles of writing, particularly journalistic styles, a paragraph
        can be just one sentence long.A paragraph is defined as “a group of
        sentences or a single sentence that forms a unit” (Lunsford and Connors
        116). Length and appearance do not determine whether a section in a
        paper is a paragraph. For instance, in some styles of writing,
        particularly journalistic styles, a paragraph can be just one sentence
        long.A paragraph is defined as “a group of sentences or a single
        sentence that forms a unit” (Lunsford and Connors 116). Length and
        appearance do not determine whether a section in a paper is a paragraph.
        For instance, in some styles of writing, particularly journalistic
        styles, a paragraph can be just one sentence long.A paragraph is defined
        as “a group of sentences or a single sentence that forms a unit”
        (Lunsford and Connors 116). Length and appearance do not determine
        whether a section in a paper is a paragraph. For instance, in some
        styles of writing, particularly journalistic styles, a paragraph can be
        just one sentence long.A paragraph is defined as “a group of sentences
        or a single sentence that forms a unit” (Lunsford and Connors 116).
        Length and appearance do not determine whether a section in a paper is a
        paragraph. For instance, in some styles of writing, particularly
        journalistic styles, a paragraph can be just one sentence long.
      </div>
    </div>
  );
};

export default Home;
